import React from 'react';
import './style.css';

const BrandingPanel: React.FC = () => {
  return (
    <div className="branding-panel">
      <iframe src="/liveolympiad_branding.html" title="LiveOlympiad Branding" />
    </div>
  );
};

export default BrandingPanel;